module.exports = __webpack_public_path__ + "img/4.ca6a51b4.jpg";